export const MAX_LABEL_NAME_LENGTH = 20;